import { render, staticRenderFns } from "./PWterms.vue?vue&type=template&id=076d2fdb&scoped=true&"
import script from "./PWterms.vue?vue&type=script&lang=js&"
export * from "./PWterms.vue?vue&type=script&lang=js&"
import style0 from "./PWterms.vue?vue&type=style&index=0&id=076d2fdb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076d2fdb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VSpacer})
